import { Route } from "react-router-dom";

import { ADD_EMPLOYEE_INCENTIVE, VIEW_EMPLOYEE } from "src/constants";
import { EMPLOYEE_ROUTES } from "src/pages/employee/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddIncentive } from "./AddIncentive.page";
import { Employees } from "./Employees.page";
import { SingleEmployee } from "./SingleEmployee.page";

/** Route tree for the employee module, mounted under `/employees` and `/employee`. */
export const employeeRoutes = (
  <>
    <Route path={EMPLOYEE_ROUTES.root} element={<ProtectedRoute permissions={VIEW_EMPLOYEE} component={Employees} />} />
    <Route
      path={EMPLOYEE_ROUTES.details}
      element={<ProtectedRoute permissions={VIEW_EMPLOYEE} component={SingleEmployee} />}
    />
    <Route
      path={EMPLOYEE_ROUTES.addIncentive}
      element={<ProtectedRoute permissions={ADD_EMPLOYEE_INCENTIVE} component={AddIncentive} />}
    />
  </>
);
